

if (!customElements.get('quick-add-modal')) {
    customElements.define(
        'quick-add-modal',
        class QuickAddModal extends ModalDialog {
            constructor() {
                super();
                this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

                this.addEventListener('product-info:loaded', ({ target }) => {
                    target.addPreProcessCallback(this.preprocessHTML.bind(this));
                });
            }

            hide(preventFocus = false) {
                const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                if (cartNotification) cartNotification.setActiveElement(this.openedBy);
                this.modalContent.innerHTML = '';

                if (preventFocus) this.openedBy = null;
                this.makeSteps();
                super.hide();
            }

            show(opener) {
                opener.setAttribute('aria-disabled', true);
                opener.classList.add('loading');
                opener.querySelector('.loading__spinner').classList.remove('hidden');

                fetch(opener.getAttribute('data-product-url'))
                    .then((response) => response.text())
                    .then((responseText) => {
                        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
                        const productElement = responseHTML.querySelector('product-info');

                        this.preprocessHTML(productElement);
                        HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

                        if (window.Shopify && Shopify.PaymentButton) {
                            Shopify.PaymentButton.init();
                        }
                        if (window.ProductModel) window.ProductModel.loadShopifyXR();

                        super.show(opener);
                        this.makeSteps();
                    })
                    .finally(() => {
                        
                        setTimeout(() => {
                            opener.removeAttribute('aria-disabled');
                        opener.classList.remove('loading');
                        opener.querySelector('.loading__spinner').classList.add('hidden');
                          }, 300);
                    });
            }

            preprocessHTML(productElement) {
                productElement.classList.forEach((classApplied) => {
                    if (classApplied.startsWith('color-') || classApplied === 'gradient')
                        this.modalContent.classList.add(classApplied);
                });
                this.preventDuplicatedIDs(productElement);
                this.removeDOMElements(productElement);
                this.removeGalleryListSemantic(productElement);
                this.updateImageSizes(productElement);
                this.preventVariantURLSwitching(productElement);

            }

            preventVariantURLSwitching(productElement) {
                productElement.setAttribute('data-update-url', 'false');
            }

            removeDOMElements(productElement) {
                const pickupAvailability = productElement.querySelector('pickup-availability');
                if (pickupAvailability) pickupAvailability.remove();

                const productModal = productElement.querySelector('product-modal');
                if (productModal) productModal.remove();

                const modalDialog = productElement.querySelectorAll('modal-dialog');
                if (modalDialog) modalDialog.forEach((modal) => modal.remove());
            }

            preventDuplicatedIDs(productElement) {
                const sectionId = productElement.dataset.section;

                const oldId = sectionId;
                const newId = `quickadd-${sectionId}`;
                productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
                Array.from(productElement.attributes).forEach((attribute) => {
                    if (attribute.value.includes(oldId)) {
                        productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
                    }
                });

                productElement.dataset.originalSection = sectionId;
            }

            removeGalleryListSemantic(productElement) {
                const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
                if (!galleryList) return;

                galleryList.setAttribute('role', 'presentation');
                galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
            }

            updateImageSizes(productElement) {
                const product = productElement.querySelector('.product');
                const desktopColumns = product?.classList.contains('product--columns');
                if (!desktopColumns) return;

                const mediaImages = product.querySelectorAll('.product__media img');
                if (!mediaImages.length) return;

                let mediaImageSizes =
                    '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

                if (product.classList.contains('product--medium')) {
                    mediaImageSizes = mediaImageSizes.replace('715px', '605px');
                } else if (product.classList.contains('product--small')) {
                    mediaImageSizes = mediaImageSizes.replace('715px', '495px');
                }

                mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
            }

            makeSteps(productElement) {
                document.querySelectorAll('.quick-add-modal').forEach(modal => {
                    const nextBtn = modal.querySelector('.js-next-step');
                    const prevBtn = modal.querySelector('.js-prev-step');
                    const firstStep = modal.querySelector('[data-popstep="first"]');
                    const secondStep = modal.querySelector('[data-popstep="second"]');
                    const closeModal = modal.querySelector('.js-close-steps');
                    const titleOne = modal.querySelector('.step-title.one');
                    const titleTwo = modal.querySelector('.step-title.two');

                    const toCart = modal.querySelector('.js-buy');
                    const properToCart = modal.querySelector('.product-form__submit ');
                    

                    function resetStep () {
                        firstStep.setAttribute('aria-hidden', 'false');
                        secondStep.setAttribute('aria-hidden', 'true');
                        nextBtn.setAttribute('aria-hidden', 'false');
                        closeModal.setAttribute('aria-hidden', 'false');
                        prevBtn.setAttribute('aria-hidden', 'true');
                        titleOne.setAttribute('aria-hidden', 'false');
                        titleTwo.setAttribute('aria-hidden', 'true');
                        toCart.setAttribute('aria-hidden', 'true');
                        console.log("Reset Step");
                        
                    }
                    

                    if (nextBtn && prevBtn && firstStep && secondStep) {
                        resetStep ();
                        nextBtn.addEventListener('click', () => {
                            nextBtn.blur();
                            firstStep.setAttribute('aria-hidden', 'true');
                            nextBtn.setAttribute('aria-hidden', 'true');
                            closeModal.setAttribute('aria-hidden', 'true');
                            secondStep.setAttribute('aria-hidden', 'false');
                            prevBtn.setAttribute('aria-hidden', 'false');
                            titleOne.setAttribute('aria-hidden', 'true');
                            titleTwo.setAttribute('aria-hidden', 'false');
                            
                            toCart.setAttribute('aria-hidden', 'false');
                            toCart.focus();
                        });

                        prevBtn.addEventListener('click', () => {
                            prevBtn.blur();
                           resetStep ();
                        });

                        closeModal.addEventListener('click', () => {
                            super.hide();
                        });

                        toCart.addEventListener('click', () => {
                            properToCart.click();
                            toCart.classList.add('wait');
                            // super.hide();
                           
                        });

                        document.addEventListener('rebuy:cart.add', (event) => { 
                            toCart.classList.remove('wait');
                            firstStep.setAttribute('aria-hidden', 'false');
                            secondStep.setAttribute('aria-hidden', 'true');
                            nextBtn.setAttribute('aria-hidden', 'false');
                            closeModal.setAttribute('aria-hidden', 'false');
                            prevBtn.setAttribute('aria-hidden', 'true');
                            titleOne.setAttribute('aria-hidden', 'false');
                            titleTwo.setAttribute('aria-hidden', 'true');
                            toCart.setAttribute('aria-hidden', 'true'); 
                        });
                    }
                });
            };
        }
    );
}

